module.exports = (__parcel__import__("glbuG")).then(() => parcelRequire('kKorg'));